import { Injectable } from '@angular/core';
import { UnitsV2 } from '@schenck/rotec-components';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import { PedestalPlane, PlaneReferenceGeometry } from 'src/utils/interfaces/rotor-type.interfaces';
import { mapToRotorTypeValue } from './adapter.mappers';
import { ToleranceModes } from 'src/utils/enums/rotor-type.enum';

export class PlaneReferenceGeometryModel implements PlaneReferenceGeometry {
  constructor(
    public readonly tolerancePlanes: {
      planes: PedestalPlane[];
      geometrySystem: { value: number; isEdited: boolean };
    }
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class PlaneReferenceGeometryAdapter
  implements Adapter<RotorTypeFormsData, PlaneReferenceGeometry>
{
  /**
   * Creates the adapted form data for plane geometry field
   *
   * @param formData: RotorTypeFormsData
   * @param units: UnitsV2[]
   * @returns PlaneReferenceGeometry
   */
  public adapt({ tolerancesStep }: RotorTypeFormsData, units: UnitsV2[]): PlaneReferenceGeometry {
    const tolerancePlanes = {
      planes: [
        {
          planeIndex: 0,
          distance: mapToRotorTypeValue(
            tolerancesStep.toleranceMode.value === ToleranceModes.Manual
              ? tolerancesStep.userDefined.tolerancePlane1Distance
              : tolerancesStep.isoCalculation.tolerancePlane1Distance,
            units
          ),
        },
        {
          planeIndex: 1,
          distance: mapToRotorTypeValue(
            tolerancesStep.toleranceMode.value === ToleranceModes.Manual
              ? tolerancesStep.userDefined.tolerancePlane2Distance
              : tolerancesStep.isoCalculation.tolerancePlane2Distance,
            units
          ),
        },
      ],
      geometrySystem: {
        value: 0,
        isEdited: true,
      },
    };

    return new PlaneReferenceGeometryModel(tolerancePlanes);
  }
}
